<h3 sidenav-title>{{ data?.title ?? 'Select Members' }}</h3>

<sidenav-content>
    <app-toggle-list [preselectedIds]="data?.selectedMembershipIds"
                     [data]="memberships"
                     [disabled]="disabledMemberships">
        <ng-template let-membership="item">
            <app-avatar-block [initials]="membership.initials">
                <span avatarTitle>{{ membership.name }}</span>
                <span avatarDescription>{{ membership.user?.email || '--' }}</span>
            </app-avatar-block>
        </ng-template>

        <toggle-list-group groupKey="admins" [groupPredicate]="adminMemberships">{{ 'Admins' }}</toggle-list-group>
        <toggle-list-group groupKey="owners" [groupPredicate]="ownerMemberships">{{ 'Owners' }}</toggle-list-group>
        <toggle-list-group groupKey="members">{{ 'Other Members' }}</toggle-list-group>

        <app-empty-state>
            <span emptyStateTitle>{{ data?.emptyStateLabel || 'No members so far...' }}</span>
        </app-empty-state>
    </app-toggle-list>
</sidenav-content>

<sidenav-actions>
    <button *isTypeof="data?.confirmButton" mat-flat-button disableRipple color="primary" (click)="confirmSelection()">
        {{ data.confirmButton | mobileButton }}
    </button>
    <button *isTypeof="(data?.confirmButton || confirmLabelMapping); check: 'object'" mat-flat-button disableRipple color="primary" (click)="confirmSelection()">
        {{ (listRef?.combinedValue?.length | i18nPlural: (data.confirmButton || confirmLabelMapping)) | mobileButton }}
    </button>
    <button-spacer></button-spacer>
    <button mat-flat-button disableRipple color="accent" sidenav-close>{{ 'Cancel' }}</button>
</sidenav-actions>
